<template>
  <div>
    <header-slot></header-slot>
    <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="active"
        :link-classes="['px-3', bgTabsNavs]"
        >{{ $t(item.title) }}
      </b-nav-item>
    </b-nav>
    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view :key="routeName" />
      <!-- <GridTable /> -->
    </b-card>
  </div>
</template>

<script>
/* Components */
import GridTable from "@/views/monitoring/views/attendance/components/GirdTable.vue";

export default {
  components: {
    GridTable,
  },
  computed: {
    tabs() {
      return this.$route.matched[1].meta.tabs;
    },
    routeName() {
      return this.$route.name;
    },
  },
};
</script>

<style>
</style>